<template>
  <div class="solution-menu">
    <template v-for="(item, i) in items">
      <SolutionsButton 
        :key="'button' + i" 
        :item="item" 
        :isActive="selected == item.name" 
        @setActive="setActive(item.name)"
        @toggleActive="toggleActive(item.name)"
      ></SolutionsButton>

      <SolutionsContent 
        :key="'content' + i"
        :item="item" 
        :content="content[i]"
        :link="readMoreLinks[i]"
        :isActive="selected == item.name"
      ></SolutionsContent>
    </template>
  </div>
</template>

<script>
import SolutionsButton from './SolutionsButton';
import SolutionsContent from './SolutionsContent';

export default {
  name: "RaHubSolutions",
  components: {
    SolutionsButton,
    SolutionsContent,
  },

  props: {
    items: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      selected: 'Koalas Forever',
      content: [
        {
          copy1: `We are directing efforts to boosting our wildlife crisis response and healthcare capacity in key landscapes across eastern Australia where our koalas are most threatened, and where the recovery potential is greatest.`,
          copy2: `To achieve this, <a>we need your support and investment to bolster the capacity of wildlife hospitals in these priority areas.</a> For every koala we assist, we can also help hundreds of other species. This work starts with funding local hospital upgrades and setting up mobile veterinary response units.`,
          copy3: `Our end goal is to build a truly state-of-the-art wildlife hospital that delivers the highest standard of care for Australia’s injured wildlife; one that also serves as an immersive, community education centre for the public.`
        },
        {
          copy1: `We can’t achieve this alone - we need your help. Together with your support, we are working with landholders, farmers, communities, businesses, traditional owners and government.`,
          copy2: `We can make the changes needed to move Australia from a deforestation hotspot to a global reforestation leader by 2030.`,
          copy3: `Australia’s forests are our shared heritage and our legacy, and <a>we all have a part to play in saving and restoring them for future generations of people and nature.</a>`
        },
        {
          copy1: `Not only does Australia have some of the best renewable energy resources in the world, we now have our best ever opportunity to harness them for national and global good.`,
          copy2: `Australia can produce enough clean and affordable energy to power our whole nation, plus have plenty left over to sell to our neighbours. We could boost our economy, create tens of thousands of new clean energy jobs and lower our domestic carbon pollution, improving the environment for all.`,
          copy3: `This is why <a>WWF-Australia is calling on you and our leaders to make Australia the world’s leading exporter of renewable energy by 2030.</a>`
        },
        {
          copy1: `Sustainability seeks to reduce harm, regeneration takes things a big step further. We aim to ‘future-proof’ Australia by supporting regenerative, community-led solutions that encourage impact investment in priority areas such as food, biodiversity and climate. Through an alliance of communities, investors, councils, corporates, innovators and think-tanks, we are establishing a powerful network capable of regenerating Australia.`,
          copy2: `Regenerative development actively reverses environmental degradation and creates a positive impact for people and the planet. WWF are seeking partners to help identify growing market opportunities in the regenerative economy, including future-focused businesses and start-ups keen to capitalise on new markets.`,
          copy3: `<a>With your help, we can address the unprecedented challenges facing our environment today</a> by enabling human systems to co-evolve with nature. Now is the time to innovate to regenerate Australia.`
        },
      ],
      readMoreLinks: [
        'https://www.wwf.org.au/what-we-do/regenerate-australia/koalas-forever#gs.4el2cf',
        'https://www.wwf.org.au/what-we-do/2-billion-trees',
        'https://www.wwf.org.au/what-we-do/climate/renewables/making-australia-a-renewable-energy-exports-powerhouse#gs.4elrs6',
        'https://www.wwf.org.au/what-we-do/regenerate-australia/innovate-to-regenerate',
      ]
    }
  },

  methods: {
    setActive(name) {
      // Only log to amplitude when value has changed
      if (this.selected !== name) {
        this.$store.dispatch('logTabView', name);
      }
      this.selected = name;
    },
    toggleActive(name) {
      // Only log to amplitude when value has changed
      if (this.selected !== name) {
        this.$store.dispatch('logTabView', name);
      }
      this.selected !== name ? this.selected = name : this.selected = '';
    }
  }
};
</script>

<style scoped>
.solution-menu {
  display: grid;
  grid-template: repeat(4, auto) / 1fr;
  margin-bottom: 2rem;
}

@media only screen and (min-width: 768px) {
  .solution-menu {
    grid-template: auto auto / repeat(4, 1fr);
  }
}
</style>


// WEBPACK FOOTER //
// RaHubSolutions.vue?3326f9a0